/**
 * Where releases live in this portal's URL — the command center's shape
 * (`/crm/releases/10.2?version=10.2.0.27`) without the `/crm` prefix.
 *
 * A release is a PLACE: a link pasted to a colleague names it in the path,
 * and which version inside it is open rides as `?version=`, a view choice
 * within the place rather than a different place. `/downloads` — the page
 * this replaced on 2026-09-14 — redirects here.
 */
export const RELEASES_PATH = "/releases";

export const VERSION_PARAM = "version";

export function releasePath(releaseVersion: string): string {
  return `${RELEASES_PATH}/${encodeURIComponent(releaseVersion)}`;
}

export function versionPath(releaseVersion: string, version: string): string {
  return `${releasePath(releaseVersion)}?${VERSION_PARAM}=${encodeURIComponent(version)}`;
}
